import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, useTheme } from '@mui/styles'
import { ButtonSquare } from '@/modules/base/components/buttons'

import CloseSvg from '@assets/images/icons/v2/close.svg'
import lang from '@/lang'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import getModalAssets from '@/modules/base/components/modal/upgrade-modal/_helpers/getModalAssets'

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'space-between',
    minWidth: 1050,
    minHeight: 580,
  },
  contentLeft: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    textAlign: 'center',
  },
  contentRight: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.signature.moduleModal.backgroundColor,
  },
  title: {
    fontSize: theme.fontSizes.xlarge,
    margin: 20,
    marginBottom: 10,
  },
  subtitle: {
    fontSize: theme.fontSizes.smedium,
    margin: 20,
  },
  button: {
    marginTop: 50,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& > button': {
      margin: '0.5rem 0',
      width: 'max-content',
    },
  },
  illustration: {
    width: 'auto',
    marginLeft: -22,
  },
  closeIcon: {
    position: 'absolute',
    top: 0,
    right: 0,
    margin: 30,
    cursor: 'pointer',
  },
  cancelButton: {
    color: theme.colorPrimaryButtonBackgroundHover,
    cursor: 'pointer',
    fontSize: theme.fontSizes.smedium,
    paddingTop: 10,
  },
}))

const BeautifulLimitReachedView = (props) => {
  const {
    title,
    subTitle,
    onAbort,
    onContinue,
    limitations,
    limit,
  } = props

  const classes = useStyles()
  const theme = useTheme()

  const { icon, illustration } = getModalAssets(limit)

  return (
    <div className={classes.wrapper}>
      <div className={classes.contentLeft}>
        <SVGIcon svg={icon} width={26} height={26} />
        <p className={classes.title}>{title}</p>
        <p className={classes.subtitle}>{subTitle}</p>
        <div className={classes.texts}>
          {limitations.texts.map((text) => <p>{text}</p>)}
          <a href={`tel:${lang.signature.moduleModal.telephone}`}>{lang.signature.moduleModal.telephone}</a>
        </div>
        <div className={classes.button}>
          <ButtonSquare label={lang.documents.planUpgradeLabel} onClick={onContinue} />
          <span onClick={onAbort} className={classes.cancelButton}>{lang.documents.planUpgradeCancelLabel}</span>
        </div>
      </div>
      <div className={classes.contentRight}>
        <SVGIcon svg={illustration} height={500} width={400} className={classes.illustration} />
      </div>
      <SVGIcon svg={CloseSvg} height={20} width={20} fill={theme.white} className={classes.closeIcon} onClick={onAbort} />
    </div>
  )
}

BeautifulLimitReachedView.propTypes = {
  onAbort: PropTypes.func,
  onContinue: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  subTitle: PropTypes.string,
  limitations: PropTypes.object,
}

export default BeautifulLimitReachedView
